module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-learn-connect.svg?143c96afdea6208efcc2205a452b6b99";